import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { PreferenceChannel } from '../../../models/preference-channel/preferente-channel.model';
import { PreferenceChannelSerializer } from '../../../models/preference-channel/preference-channel-serializer.class';

@Injectable()
export class PreferenceChannelService extends BaseApiService<PreferenceChannel> {
    constructor(httpClient: HttpClient) {
        super(
            httpClient, 
            null, 
            "preferencechannels",
            new PreferenceChannelSerializer(), 
            new CustomErrorHandlerService()
        );
    }
}